module.exports = __webpack_public_path__ + "img/tractor_home.b13b1c0e.png";